module.exports = __webpack_public_path__ + "img/gard_vertical_2.b2564440.png";